import PropTypes from 'prop-types'
import data from 'emoji-mart/data/apple.json'

export function unifiedToNative(unified) {
  const unicodes = unified.split('-')
  const codePoints = unicodes.map(u => `0x${u}`)
  return String.fromCodePoint.apply(null, codePoints)
}

export const EmojiPropTypes = PropTypes.shape({
  id: PropTypes.string,
  a: PropTypes.string.isRequired, // Title ( Grinning Point )
  b: PropTypes.string, // Unified
  c: PropTypes.string, // Unified
  j: PropTypes.array, // Keywords
  l: PropTypes.array, // Emoticons shortcut ( 8-D )
  n: PropTypes.array, //Shortnames
})

export function getEmojiTitle(emoji) {
  return emoji.a
}

export function getEmojiNativeText(emoji) {
  return unifiedToNative(emoji.b || emoji.c)
}

export function buildEmojiSearch() {
  // Add top emojis on top, Sort correctly the rest
  const updatedCategories = sortedCategoryIds.map(
    id1 => data.categories.filter(({ id }) => id === id1)[0]
  )
  const topCategory = { emojis: topEmojis }
  updatedCategories.unshift(topCategory)

  return updatedCategories.reduce((memo, category) => {
    const emojis = category.emojis.map(id => {
      const emoji = data.emojis[id]
      const searchNames = [id].concat(emoji.n || []).concat(emoji.j || [])
      const searchEmoticons = emoji.l || []
      return { id, ...emoji, searchNames, searchEmoticons }
    })
    return memo.concat(emojis)
  }, [])
}

function findEmojiSearchNames(emoji, query) {
  return (
    emoji.searchNames.find(s => s.includes(query)) ||
    emoji.searchEmoticons.find(s => s.includes(`:${query}`))
  )
}

export function buildEmojiList(query = '', index = buildEmojiSearch()) {
  if (query.length === 0) {
    return index
  }
  const uniqueResultIds = []
  return index
    .filter(emoji => {
      if (uniqueResultIds.includes(emoji.id)) {
        return false
      }
      uniqueResultIds.push(emoji.id)
      return findEmojiSearchNames(emoji, query)
    })
    .sort((a, b) => {
      return (
        findEmojiSearchNames(a, query).indexOf(query) -
        findEmojiSearchNames(b, query).indexOf(query)
      )
    })
}

const sortedCategoryIds = [
  'objects',
  'activity',
  'places',
  'people',
  'nature',
  'symbols',
  'foods',
  'flags',
]

const topEmojis = [
  'mega',
  'studio_microphone',
  'microphone',
  'iphone',
  'computer',
  'bulb',
  'dollar',
  'briefcase',
  'file_folder',
  'calendar',
  'hammer_and_wrench',
  'crossed_swords',
  'scales',
  'crystal_ball',
  'sparkles',
  'dart',
  'earth_americas',
  'world_map',
  'art',
  'tent',
  'bullettrain_front',
  'motorway',
  'airplane',
  'rocket',
  'clock12',
  'clock3',
  'star',
  'zap',
  'fire',
  'male-technologist',
  'female-technologist',
  'princess',
  'prince',
  'no_good',
  'man-gesturing-no',
  'dancers',
  'man-with-bunny-ears-partying',
  'muscle',
  'selfie',
  'clap',
  'eyes',
  'boom',
  'writing_hand',
  'speech_balloon',
  'necktie',
  'thought_balloon',
  'no_entry_sign',
  'warning',
  'white_check_mark',
  'negative_squared_cross_mark',
  'x',
  'exclamation',
  '100',
  'popcorn',
  'clinking_glasses',
]
